import SiteNav from "@/pages/home/components/SiteNav";
import Hero from "@/pages/home/components/Hero";
import QuickFacts from "@/pages/home/components/QuickFacts";
import Story from "@/pages/home/components/Story";
import PlayLines from "@/pages/home/components/PlayLines";
import Versions from "@/pages/home/components/Versions";
import WatchGuide from "@/pages/home/components/WatchGuide";
import Faq from "@/pages/home/components/Faq";
import Recommendations from "@/pages/home/components/Recommendations";
import Notice from "@/pages/home/components/Notice";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteNav />
      <main className="w-full">
        <Hero />
        <QuickFacts />
        <Story />
        <PlayLines />
        <Versions />
        <WatchGuide />
        <Faq />
        <Recommendations />
        <Notice />
      </main>
      <SiteFooter />
    </div>
  );
}